import React, { useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
} from "reactstrap";
import { logout, getAuthUserFullname, getAuthProgram} from "../../App/auth";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Avatar from "@/shared/components/Avatar";

const TopbarProfile = ({ isManager, auth, template }) => {
  const { t } = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  let navigate = useNavigate();

  const onClickMyAccount = () => {
    let path = isManager ? "manager" : "participant";
    navigate(`/` + path + `/my-account`);
  };

  const onClickAccountView = () => {
    let path = isManager ? "participant" : "manager";
    navigate(`/` + path + `/home`);
  };

  const programRoles = auth?.programRoles || {};

  // flatten all role names across programs
  const roleNames = Object.values(programRoles)
    .flatMap(program =>
      program.roles ? Object.values(program.roles) : []
    )
    .map(role => role.name?.toLowerCase());

  const hasManagerRole = roleNames.includes('manager');
  const hasParticipantRole = roleNames.includes('participant');
  // allow switch ONLY if both roles exist in this program
  const canSwitchView = hasManagerRole && hasParticipantRole;

  if( ! auth?.id ) return '...'

  const Ava = auth.avatar
    ? `${process.env.REACT_APP_API_STORAGE_URL}/` + auth.avatar
    : "";

  return (
    <div className="topbar__profile">
      <UncontrolledDropdown inNavbar>
        <DropdownToggle caret nav className="topbar__avatar">
          <Avatar className="topbar__avatar-img" fallbackClassName="topbar__avatar-img" src={Ava} name={getAuthUserFullname()} />
          <strong className="topbar__avatar-name">{getAuthUserFullname()}</strong>
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem onClick={() => onClickMyAccount()}>
            {t("my_account")}
          </DropdownItem>
          {canSwitchView && (
            <DropdownItem onClick={onClickAccountView}>
              {isManager ? t("participant_view") : t("manager_view")}
            </DropdownItem>
          )}
          <DropdownItem divider />
          <DropdownItem onClick={() => setShowLogoutModal(true)}>
            {t("sign_out")}
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>

      {isCollapsed && (
        <button
          type="button"
          aria-label="button collapse"
          className="topbar__back"
          onClick={handleToggleCollapse}
        />
      )}

      <Modal isOpen={showLogoutModal} toggle={() => setShowLogoutModal(false)} centered size="sm">
        <ModalBody className="logout-confirm">
          <div className="logout-confirm__icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </div>
          <h4 className="logout-confirm__title">Sign out?</h4>
          <p className="logout-confirm__message">You'll be returned to the login page.</p>
          <div className="logout-confirm__actions">
            <button type="button" className="logout-confirm__cancel" onClick={() => setShowLogoutModal(false)}>
              Cancel
            </button>
            <button type="button" className="logout-confirm__confirm" onClick={logout}>
              Sign out
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default connect((state) => ({
  auth: state.auth,
  template: state.template
}))(TopbarProfile);
